import React, { FunctionComponent } from 'react';

import { ImageMedia } from '../../../../types/__generated__';
import { onlyImages } from '../../../utils/typeGuards';
import { ImageGridWithLightbox } from '../../ImageGrid';
import { FitnessMessage } from '../Fitness/FitnessMessage';
import { TimelineEntryProps } from './TimelineEntry';

import styles from '../Timeline.scss';

export type BodyProps = Pick<TimelineEntryProps, 'timelineEntry'> & {
  showPhotos?: boolean;
};

export const Body: FunctionComponent<BodyProps> = ({
  timelineEntry: { message, media, fitnessActivity },
  showPhotos = true,
  children,
}) => {
  const images = media?.filter(onlyImages);
  return (
    <div className={styles.body}>
      {children ? (
        children
      ) : fitnessActivity ? (
        <FitnessMessage
          message={message}
          caption="Fitness information"
          fitness={fitnessActivity!}
        />
      ) : (
        <div className={styles.bodyMessage}>{message}</div>
      )}
      {showPhotos && images && images.length > 0 && (
        <ImageGridWithLightbox
          gridType="template"
          className={styles.bodyGallery}
          images={images.map((m: ImageMedia) => ({
            ...m,
            loading: false,
            id: m.id,
            type: m.__typename,
            url: m.url || '',
          }))}
        />
      )}
    </div>
  );
};
Body.displayName = 'TimelineEntryBody';
